import React from 'react';
import { motion } from 'framer-motion';
import { OfferSelector } from '../ui/OfferSelector';
export function FinalCTA() {
  return <section className="py-20 px-4 bg-black relative" data-id="element-95">
      <div className="absolute inset-0 bg-hero-pattern opacity-50 pointer-events-none" data-id="element-96" />

      <div className="max-w-3xl mx-auto relative z-10 text-center" data-id="element-97">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-98">
          <h2 className="text-4xl md:text-6xl font-display uppercase text-white mb-6" data-id="element-99">
            NO SIGAS POSTERGANDO TU CAMBIO
          </h2>

          <div className="text-base md:text-xl text-gray-400 mb-8 space-y-1" data-id="element-100">
            <p data-id="element-101">Cada día que pasa tu energía baja y tu motivación desaparece.</p>
            <p className="text-white font-bold mt-3" data-id="element-102">
              Pero hoy puedes cambiar eso.
            </p>
          </div>

          <div className="bg-dark-card/80 backdrop-blur border border-dark-border p-5 md:p-8 rounded-2xl md:rounded-3xl" data-id="element-103">
            <h3 className="text-2xl md:text-3xl font-display text-brand mb-1 uppercase" data-id="element-104">
              Empezá hoy mismo
            </h3>
            <p className="text-sm md:text-base text-gray-300 mb-6" data-id="element-105">
              Transformá tu cuerpo y tu mente desde casa.
            </p>

            <OfferSelector variant="compact" ctaLabel="QUIERO ACCEDER AHORA" data-id="element-106" />
          </div>
        </motion.div>
      </div>
    </section>;
}